<template>
  <v-card flat rounded="lg">
    <v-card-title class="primary--text">Meus Dados Pessoais</v-card-title>
    <v-card-text>
      <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
      <dados-pessoais v-else />
    </v-card-text>
  </v-card>
</template>

<script>
import DadosPessoais from "@/components/inscricao/DadosPessoais.vue";
import { mapActions } from 'vuex';
export default {
  components: { DadosPessoais },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions(["getDadosGerais","getEscolaridades"])
  },
  async created(){
    this.loading = true
    await this.getEscolaridades();
    await this.getDadosGerais()
    this.loading = false
  }
};
</script>

<style>
</style>